import React, { useState } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { OrientationProvider } from './contexts/OrientationContext'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import DesktopContent from './components/DesktopContent/DesktopContent'
import OrientationWarning from './components/OrientationWarning/OrientationWarning'
import ResetPassword from './pages/ResetPassword'
import EmailVerification from './pages/EmailVerification'
import EaseStamp from './pages/EaseStamp'
import defaultBackground from './assets/background/background-1.jpg'
import './App.css'
import './styles/global.css'

function App() {
  const [backgroundImage, setBackgroundImage] = useState(() => {
    // 从 localStorage 获取背景图片
    return localStorage.getItem('backgroundImage') || defaultBackground
  })

  const updateBackgroundImage = newImage => {
    setBackgroundImage(newImage)
    // 将新的背景图片存储到 localStorage
    localStorage.setItem('backgroundImage', newImage)
  }

  // 主页面组件
  const MainPage = () => (
    <OrientationWarning>
      <div
        className="app"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Header title="Yichen Wang" />
        <DesktopContent />
        <Footer onChangeBackground={updateBackgroundImage} />
      </div>
    </OrientationWarning>
  )

  return (
    <OrientationProvider>
      <Router>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/easestamp" element={<EaseStamp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </OrientationProvider>
  )
}

export default App
